/* global ga, $zopim */
function analytics() {

}

var cookieBarOptions = {
  declineButton: false,
  autoEnable: false,
  message: 'Nous utilisons des cookies afin de mieux connaitre votre utilisation et vos préférences. En continuant votre navigation, vous en acceptez l\'utilisation.',
  acceptText: 'Je comprends',
  declineText: 'Désactiver',
  policyText: 'Confidentialité des données',
  acceptOnContinue: true,
  acceptCallback: analytics,
  authorizedCookies: ['PHPSESSID','REMEMBERME','cb-enabled','discount-code'],
  domain: '.wheeliz.com'
};

(function($) {
  $.cookieBar(cookieBarOptions);

  if ($.cookieAccepted()) {
    analytics();
  }
})(jQuery);
